import api from "../../../services/api.service"


export const typeformModule = {
    namespaced: true,
    state: {
        data: {types:[],categories:[]},
    },
    getters: {
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },

        allTypeformStatus() {
            return [
                { value: "online", text: ('ONLINE') },
                { value: "offline", text: ('OFFLINE') },
                { value: "inProgress", text: ('IN PROGRESS') },
                { value: "error", text: ('ERROR') }
            ];
        },



    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {

        copySuccess(actions,id){
            actions.dispatch('notifications/success',
                {title: 'Success', message: 'Typeform  ID '+id+' copied'},
                {root: true});

        },


        getForms(actions) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('typeform/forms', {
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(",")
                }, null).then(
                    (ans) => {
                        resolve(ans['Forms'] || [])
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        getAll(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {

                    api.sendRequest('typeform/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["Typeforms"] == null)
                                return reject('Could not get Typeforms ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

        },


        deleteOne(actions,{id}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/delete/'+id, {}).then(
                    (ans) => {

                        if (ans["Deleted"] == null)
                            return reject('Could not delete item ');

                        resolve(ans["Deleted"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        updateTypeForm(actions,{form}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/update',null, form).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update form', message: 'Updated successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not update form ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        createTypeForm(actions,{form}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/create',null, form).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Create form', message: 'Created successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not create form ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        bulkCreate(actions, {leads}) {
            return new Promise((resolve, reject) => {
                api.sendRequest('typeform/bulk-create', null, leads).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Bulk Import', message: `Created ${ans.Created || 0} leads` + (ans.Failed ? `, ${ans.Failed} failed` : '')},
                            {root: true});
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        convertLead(actions,id){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/convert/'+id,null, null).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Convert Lead', message: 'Converted successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not convert lead ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        getMailHistory(actions, {page, amount, filter, sortcolumn, sortby}) {
            if (typeof filter !== "object")
                filter = {};
            return new Promise(function (resolve, reject) {
                api.sendRequest('typeform/mail/get', {
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                    page,
                    amount,
                    sortcolumn,
                    sortby,
                }, filter).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: 'Mail History',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        },

        sendMailEvent(actions, {id, mailType}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('typeform/mail/' + id + '/' + mailType).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Email', message: 'Mail sent successfully'},
                            {root: true});
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: 'Email',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        },

        updateStatus(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {

                    api.sendRequest('typeform/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["Typeforms"] == null)
                                return reject('Could not get Typeforms ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

        },


    },
};
